import React, { useState, useEffect } from "react";
import Countdown from "react-countdown";

import { startDate, twoDigit, findCurrentEvent } from "@utils/schedule";
import classnames from "@utils/classnames";
import Lottie from "@components/lottie";
import Container from "@components/container";
import Box from "@components/box";

import styles from "./header.module.scss";

import motion1 from "@images/animation/motion1.json";
import motion2 from "@images/animation/motion2.json";
import motion3 from "@images/animation/motion3.json";
import motion4 from "@images/animation/motion4.json";
import motion5 from "@images/animation/motion5.json";

import logoImage from "@images/logo.png";
import supportsImage from "@images/supports-shadow.png";

const counterRenderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return null;
  }
  return (
    <div className={styles.countdown}>
      {[
        ["天", twoDigit(days)],
        ["时", twoDigit(hours)],
        ["分", twoDigit(minutes)],
        ["秒", twoDigit(seconds)]
      ].map(item => {
        return (
          <div key={item[0]}>
            <div>
              <span>{item[1]}</span>
            </div>
            <span>{item[0]}</span>
          </div>
        );
      })}
    </div>
  );
};

const getCurrentDateEvent = () => findCurrentEvent(30 * 60 * 1000);

const Header = () => {
  const [activeTopbar, setActiveTopbar] = useState(false);
  // const [currentEvent, setCurrentEvent] = useState(null);
  const [needStart, setNeedStart] = useState(false);
  const currentEvent = true;

  useEffect(() => {
    setActiveTopbar(true);
    // setInterval(() => {
    //   setCurrentEvent(getCurrentDateEvent());
    // }, 1 * 60 * 1000);
    // setCurrentEvent(getCurrentDateEvent());
  }, []);

  const willStart = needStart || currentEvent;

  return (
    <div
      className={classnames(styles.header, {
        [styles.headerStreaming]: willStart
      })}
    >
      <div
        className={classnames(styles.topbar, {
          [styles.topbarActive]: activeTopbar
        })}
      ></div>
      <Container className={styles.body}>
        <div>
          <Lottie animationData={motion4} className={styles.dRect} />
          <Lottie animationData={motion1} className={styles.dDots2} />
          <Lottie animationData={motion3} className={styles.dDots4} />
          <Lottie animationData={motion2} className={styles.dCircle} />
          <Lottie animationData={motion5} className={styles.dRectDots} />
          {willStart ? (
            <div className={styles.streaming}>
              <h1>
                <img
                  className={styles.streamingLogo}
                  src={logoImage}
                  alt="logo"
                />
                8.5 ~ 8.8
              </h1>
              <Box color="red" className={styles.streamingBox}>
                <div className="video">
                  <div>
                    <iframe
                      width="100%"
                      height="100%"
                      frameBorder="0"
                      scrolling="no"
                      src="https://liveshare.huya.com/iframe/gcores"
                    />
                  </div>
                </div>
              </Box>
            </div>
          ) : (
            <div className={styles.logo}>
              <img className={styles.gfest} src={logoImage} alt="logo" />
              <h3 className={styles.hejiahuan}>线上游戏联欢会</h3>
              {/* <img className={styles.hejiahuan} src={hejiahuanImage} alt="logo" /> */}
              <Countdown
                date={+startDate}
                renderer={counterRenderer}
                onComplete={() => {
                  setNeedStart(true);
                }}
              />
            </div>
          )}
        </div>
      </Container>
      <div className={styles.btm}>
        <Container>
          <Box thin texture="cloud">
            <div className={styles.supports}>
              <img className="fluidImage" src={supportsImage} alt="主办方" />
            </div>
          </Box>
        </Container>
      </div>
    </div>
  );
};

export default Header;
